import { createAsyncThunk } from '@reduxjs/toolkit';
import { 
    R_getParameters, 
    R_getLibraryParameters,
    R_getParameterById,
    R_createParameter, 
    R_updateParameter, 
    R_deleteParameter,
    R_copyParameter,
    R_getAvailableAssetTypes,
    R_getTagAttributesForCalculator
} from 'api/propertyCalculator/service';
import { 
    CreateParameterRequest, 
    UpdateParameterRequest,
    GetParametersRequest,
    GetLibraryParametersRequest,
    GetTagAttributesForCalculatorRequest
} from 'api/propertyCalculator/types';

export const T_getParameters = createAsyncThunk(
    'propertyCalculator/getParameters',
    async (request: GetParametersRequest, thunkAPI) => {
        return await R_getParameters(request, thunkAPI);
    }
);

export const T_getLibraryParameters = createAsyncThunk(
    'propertyCalculator/getLibraryParameters',
    async (request: GetLibraryParametersRequest, thunkAPI) => {
        return await R_getLibraryParameters(request, thunkAPI);
    }
);

export const T_getParameterById = createAsyncThunk(
    'propertyCalculator/getParameterById',
    async (id: string, thunkAPI) => {
        return await R_getParameterById(id, thunkAPI);
    }
);

export const T_createParameter = createAsyncThunk(
    'propertyCalculator/createParameter',
    async (data: CreateParameterRequest, thunkAPI) => {
        return await R_createParameter(data, thunkAPI);
    }
);

export const T_updateParameter = createAsyncThunk(
    'propertyCalculator/updateParameter',
    async (data: UpdateParameterRequest, thunkAPI) => {
        return await R_updateParameter(data, thunkAPI);
    }
);

export const T_deleteParameter = createAsyncThunk(
    'propertyCalculator/deleteParameter',
    async (id: string, thunkAPI) => {
        return await R_deleteParameter(id, thunkAPI);
    }
);

export const T_copyParameter = createAsyncThunk(
    'propertyCalculator/copyParameter',
    async (data: { id: string; userId: string }, thunkAPI) => {
        return await R_copyParameter(data, thunkAPI);
    }
);

export const T_getAvailableAssetTypes = createAsyncThunk(
    'propertyCalculator/getAvailableAssetTypes',
    async (_, thunkAPI) => {
        return await R_getAvailableAssetTypes(thunkAPI);
    }
);

export const T_getTagAttributesForCalculator = createAsyncThunk(
    'propertyCalculator/getTagAttributes',
    async (request: GetTagAttributesForCalculatorRequest, thunkAPI) => {
        return await R_getTagAttributesForCalculator(request, thunkAPI);
    }
);

